import { Box, ButtonBase, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router";

import { SimulationCharts } from "@/components/management/SimulationCharts";
import { SimulationSettings } from "@/components/management/SimulationSettings";
import { layoutTokens as layout, semanticColors as colors, textStyles } from "@/designTokens";
import { useDevice } from "@/hooks/useDevice";
import { BaseTemplate } from "@/layouts/BaseTemplate";
import theme from "@/theme";

import { SimulationConfigCustomBalanceModal } from "./components/CustomSettingBalance";
import { SimulationConfigCustomPriceLoanModal } from "./components/CustomSettingPriceLoan";

const useStyles = makeStyles({
  root: {
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "minmax(0,384px) minmax(0,1fr)",
      gap: layout.space[40],
      paddingTop: layout.space[24],
    },
  },
  custom: { maxWidth: 776, margin: "0 auto", background: colors["surface/card"], borderRadius: layout.radius.lg },
  title: { ...textStyles["PC/Heading/H2"], padding: "24px 0" },
  back: { minHeight: 44, color: colors["action/primary"], ...textStyles["PC/Button/M"] },
});

export const ManagementDetailSimulationConfigPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { isMobile } = useDevice();
  const [custom, setCustom] = React.useState(new URLSearchParams(history.location.search).get("custom") === "1");
  const onBack = () => (custom ? setCustom(false) : history.goBack());
  const close = () => setCustom(false);
  return (
    <BaseTemplate
      headerTitle={isMobile ? (custom ? "カスタム設定" : "シミュレーション設定") : undefined}
      onBack={isMobile ? onBack : undefined}
      isDense
      isPcV2
    >
      {!isMobile && (
        <Box style={{ maxWidth: custom ? 776 : undefined, margin: "0 auto" }}>
          <ButtonBase className={classes.back} onClick={onBack}>
            戻る
          </ButtonBase>
          <Typography component="h1" className={classes.title}>
            {custom ? "カスタム設定" : "シミュレーション"}
          </Typography>
        </Box>
      )}
      {custom ? (
        <Box className={classes.custom}>
          <Box p={3}>
            <Typography variant="body2">
              この物件のシミュレーション条件を設定します。所得税率は全物件に適用される共通設定です。
            </Typography>
          </Box>
          <SimulationConfigCustomPriceLoanModal inline onClose={close} onClickCancel={close} onClickSave={close} />
          <SimulationConfigCustomBalanceModal inline onClose={close} onClickCancel={close} onClickSave={close} />
        </Box>
      ) : (
        <Box className={classes.root}>
          <SimulationSettings onCustomize={() => setCustom(true)} />
          {!isMobile && <SimulationCharts />}
        </Box>
      )}
    </BaseTemplate>
  );
};
